'use client'

import React, { FC, ReactElement } from 'react'
import styles from './Tabs.module.css'
import classNames from 'classnames'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

export type Tab = {
	title: string
	onClick: () => void
	selected: boolean
	status?: any
	tooltip?: string
}

const Tabs: FC<{ tabs: Tab[]; className?: string; containerClassName?: string }> = (
	props
): ReactElement => {
	const { className, containerClassName } = props

	const renderTab = React.useCallback(
		({ title, selected, onClick, status, tooltip: _tooltip }: any, i: any) => (
			<div
				key={i}
				className={classNames(
					'flex items-center justify-center first:rounded-l-full last:rounded-r-full cursor-pointer bg-chrome-muted px-4 h-[28px] text-xs font-semibold whitespace-nowrap',
					styles.tab,
					{
						[styles.tabSelected]: selected
					}
				)}
				onClick={onClick}
				role="button"
				tabIndex={0}
				onKeyDown={onKeyboardClick(onClick)}
			>
				{title}
				{status && status}
			</div>
		),
		[]
	)

	return (
		<div className={classNames('flex justify-center', { [props.className as any]: !!className })}>
			<div
				className={classNames(
					{
						[props.containerClassName as any]: !!containerClassName
					},
					'flex justify-center gap-[2px] px-2 select-none'
				)}
			>
				{props.tabs.map(renderTab)}
			</div>
		</div>
	)
}

export default Tabs
